import { DatePipe, formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-create-transport',
  templateUrl: './create-transport.component.html',
  styleUrls: ['./create-transport.component.scss']
})
export class CreateTransportComponent implements OnInit {
  isAdding = false;
  CreateTransportModel: any = {};
  TransportList;
  myDate;
  isUploadImage;
  imageSrc;

  constructor(private router: Router, private datePipe: DatePipe, private http: HttpClient, private toastr: ToastrService,private TokenService: TokenService) {
    this.myDate = new Date();
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['ShippingMethodDefinitions']) {
      router.navigateByUrl('/');
    }
  }

  ngOnInit() {
  }


  AddTransport() {
    this.isAdding = true;
    const body = {
      TransportWayRef: this.CreateTransportModel.TransportWayRef, TransportWayDefinitionTR: this.CreateTransportModel.TransportWayDefinitionTR,
      TransportWayDefinitionEN: this.CreateTransportModel.TransportWayDefinitionEN, TransportWayDefinitionRU: this.CreateTransportModel.TransportWayDefinitionRU,
      ImageURL: this.CreateTransportModel.ImageURL, IsDeleted : false
    };
    this.http.post<any>(environment.url + 'TransportWays/AddTransportWay', body).subscribe(data => {
      if (!data.Error) {
        this.isAdding = false;
        this.toastr.success("Transfer Yolu Eklendi !", '', {
          timeOut: 2000,
        });
        this.router.navigate(["/home/definitions/transport-list"]);
      }
    },
      error => {
        this.toastr.error('Transfer Yolu Eklenemedi!', 'Hata!', {
          timeOut: 2000,
        });
        this.isAdding = false;
      });

  }

  openImage() { // Click Image File Button
    let element: HTMLElement = document.getElementById('addimage') as HTMLElement;
    element.click();
  }
  addImageChange(files: FileList) { // Show Image File on change 
    this.isUploadImage = true;

    const formData = new FormData();
    if (files) {
      formData.append('file', files[0]);
    }
    this.http.post<any>(environment.url + 'TransportWays/UploadTransportImage', formData).subscribe(data => {
      this.isUploadImage = false;
      if (data) {
        if (files) {
          const reader = new FileReader();
          reader.readAsDataURL(files[0]);
          reader.onload = () => {
            this.imageSrc = reader.result as string;
            this.CreateTransportModel.ImageURL = data;
          };
        }
        this.toastr.success("İcon Yüklendi", '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error("İcon Yüklenemedi", 'Hata !', {
          timeOut: 3000,
        });
      }
    });

  }
}
